import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';
export const actions = {
    REQUEST: createAction('ACCOUNTS/NATURAL_USER/REQUEST'),
    SUCCESS: createAction('ACCOUNTS/NATURAL_USER/SUCCESS'),
    ERROR: createAction('ACCOUNTS/NATURAL_USER/ERROR'),
    UPDATE: createAction('ACCOUNTS/NATURAL_USER/UPDATE'),
};
export const initialState = Map({
    data: null,
    isProcessing: null,
    error: null,
    loaded: false,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.set('isProcessing', true).set('error', false),
    [actions.SUCCESS]: (state, action) => state
        .set('data', action.payload)
        .set('isProcessing', false)
        .set('error', false)
        .set('loaded', true),
    [actions.ERROR]: (state) => state.set('isProcessing', false).set('error', true).set('loaded', true),
    [actions.UPDATE]: (state, action) => {
        const currentData = state.get('data');
        return state
            .set('data', Object.assign(Object.assign({}, currentData), action.payload))
            .set('isProcessing', false)
            .set('error', false)
            .set('loaded', true);
    },
}, initialState);
export const emailSelector = (state) => {
    const data = state.naturalUser.get('data');
    return data && data.boxes && data.boxes[0] && data.boxes[0].identifier;
};
export default reducer;
